// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__Gunho","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__ss+Mj"};